module.exports = __webpack_public_path__ + "static/media/giantbomb.21962b76.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/about/giantbomb.png
// module id = 1483
// module chunks = 0